import {classNames} from '@cohort/shared-frontend/utils/classNames';
import EmptySection from '@cohort/wallet/components/space/EmptySection';
import JourneyCard from '@cohort/wallet/components/space/JourneyCard';
import useSpaceContext from '@cohort/wallet/hooks/useSpaceContext';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import type {CampaignJourneyWDto} from '@cohort/wallet-schemas/campaign';
import {Flag} from '@phosphor-icons/react';
import React, {Fragment} from 'react';
import {useTranslation} from 'react-i18next';

type JourneysListProps = {
  campaigns: Array<CampaignJourneyWDto>;
};

const JourneysList: React.FC<JourneysListProps> = ({campaigns}) => {
  const {space} = useSpaceContext();
  const {hasDarkBg} = useThemeContext();
  const {t} = useTranslation('components', {keyPrefix: 'space.journeysList'});

  if (space === undefined) {
    return <Fragment />;
  }

  if (campaigns.length === 0) {
    return (
      <EmptySection
        icon={
          <Flag
            className={classNames(
              'block h-8 w-8 place-items-center',
              hasDarkBg ? 'text-white' : 'text-black'
            )}
            aria-hidden="true"
          />
        }
        title={t('emptyJourneysListTitle')}
        subtitle={t('emptyJourneysListSubtitle')}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-5 lg:[grid-template-columns:repeat(auto-fill,minmax(var(--journey-card-min-width),1fr))]">
      {campaigns.map(campaign => (
        <JourneyCard key={campaign.id} campaign={campaign} />
      ))}
    </div>
  );
};

export default JourneysList;
